import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 * 部门相关接口
 */
const department = {

      /**
       * 搜索员工
       */
      searchStaff(key){
        return axios.post(ipAddress.qi+'/admin/a1/staff/listLikeKey',QS.stringify({
            key:key
        }),false)
      },

      /**
       * 部门选择
       */
      departList(){
        return axios.post(ipAddress.qi+'/admin/a1/department/listByStaff',null,false)
      },

      //权限列表
      groupList(){
        return axios.post(ipAddress.qi+'/admin/a1/cms-role/listGroup',null,false)
      },

      /**
       * 搜索城市
       */
      searchCity(key){
        return axios.post(ipAddress.qi+'/admin/a1/city/listLikeKey',{
          key:key,
          type:1  //1为国内
        },true)
      },

      //添加部门
      addDepart(form){
        return axios.post(ipAddress.qi+'/admin/a1/department/save',form,true)
      },

      //部门列表
      departShow(){
        return axios.post(ipAddress.qi+'/admin/a1/department/framework',null,false)
      },
      //部门详情
      departInfo(id){
        return axios.post(ipAddress.qi+'/admin/a1/department/getById',QS.stringify({
            id:id
        }),false)
      },
      //修改部门信息
      departUpdate(form){
        return axios.post(ipAddress.qi+'/admin/a1/department/updateById',form,true)
      },
       //删除部门
       departDelete(id){
        return axios.post(ipAddress.qi+'/admin/a1/department/delById',QS.stringify({
            id:id
        }),false)
      },


}
export default department;



// WEBPACK FOOTER //
// ./src/js/department/department.js